import { render, staticRenderFns } from "./caiGouInPurchasingLowPrice.vue?vue&type=template&id=5baac1da&scoped=true"
import script from "./caiGouInPurchasingLowPrice.vue?vue&type=script&lang=js"
export * from "./caiGouInPurchasingLowPrice.vue?vue&type=script&lang=js"
import style0 from "./caiGouInPurchasingLowPrice.vue?vue&type=style&index=0&id=5baac1da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baac1da",
  null
  
)

export default component.exports